module.exports = __webpack_public_path__ + "img/turkiye-sigorta.37b0c6ff.jpg";